import { MainAppResource } from './base';

export default {
  get({ projectCode, substationCode, agentCode, deviceType, modbusAddress, ...params }) {
    const queryParams = { page: { number: 1, size: 3 }, ...params };
    let path = `api/v3/projects/${projectCode}/substations/${substationCode}/agents/${agentCode}`;
    if (modbusAddress) {
      path = `${path}/devices/${deviceType}/${modbusAddress}/waveforms`;
    } else {
      path = `${path}/device/${deviceType}/waveforms`;
    }
    return MainAppResource(path).get(queryParams);
  }
};
